module.exports = __webpack_public_path__ + "img/羊角禄段贡园.9800bd98.png";